"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tally = void 0;
var tally_1 = require("./tally");
Object.defineProperty(exports, "Tally", { enumerable: true, get: function () { return __importDefault(tally_1).default; } });
//# sourceMappingURL=index.js.map